import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';
import { BlockchainNameType } from '../../../constant/currency';

export const ACTION_REQUEST_SWAP_POINT_FOR_CRYPTO = 'ACTION_REQUEST_SWAP_POINT_FOR_CRYPTO';
export const REQUEST_SWAP_POINT_FOR_CRYPTO = 'REQUEST_SWAP_POINT_FOR_CRYPTO';
export const REQUEST_SWAP_POINT_FOR_CRYPTO_SUCCESS = 'REQUEST_SWAP_SUCCESS_POINT_FOR_CRYPTO';
export const REQUEST_SWAP_POINT_FOR_CRYPTO_FAILURE = 'REQUEST_SWAP_FAILURE_POINT_FOR_CRYPTO';
export const UPDATE_BODY_SWAP = 'UPDATE_BODY_SWAP';

export const ACTION_REQUEST_CALCULATE_POINT_TO_TOKEN = 'ACTION_REQUEST_CALCULATE_POINT_TO_TOKEN';
export const REQUEST_CALCULATE_POINT_TO_TOKEN = 'REQUEST_CALCULATE_POINT_TO_TOKEN';
export const REQUEST_CALCULATE_POINT_TO_TOKEN_SUCCESS = 'REQUEST_CALCULATE_POINT_TO_TOKEN_SUCCESS';
export const REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE = 'REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE';
export const UPDATE_POINT_AMOUNT = 'UPDATE_POINT_AMOUNT';

// Check Xaman Trust Line
export const ACTION_CHECK_TRUST_LINE = 'ACTION_CHECK_TRUST_LINE';
export const REQUEST_CHECK_TRUST_LINE = 'REQUEST_CHECK_TRUST_LINE';
export const REQUEST_CHECK_TRUST_LINE_SUCCESS = 'REQUEST_CHECK_TRUST_LINE_SUCCESS';
export const REQUEST_CHECK_TRUST_LINE_FAILURE = 'REQUEST_CHECK_TRUST_LINE_FAILURE';

const defaultState = {
  requestBodySwap: {
    network: BlockchainNameType.bsc,
    memo: '',
    pointAmount: 0,
  },
  isSwap: false,
  swapFail: false,
  swapSuccess: false,

  tokenAmount: 0,
  isCalculate: false,
  calculateFail: false,
  calculateSuccess: false,

  // check Xaman trustline
  checkingTrustLineWallet: false,
  checkingTrustLineWalletSuccess: false,
  checkingTrustLineWalletFailure: false,
};

const reducer = createReducer(defaultState, {
  [REQUEST_SWAP_POINT_FOR_CRYPTO]: (state, _action) => ({
    ...state,
    isSwap: true,
    swapFail: false,
    swapSuccess: false,
  }),
  [REQUEST_SWAP_POINT_FOR_CRYPTO_SUCCESS]: (state) => ({
    ...state,
    requestBodySwap: {
      network: BlockchainNameType.bsc,
      walletAddress: '',
      memo: '',
      pointAmount: 0,
    },
    tokenAmount: 0,
    isSwap: false,
    swapFail: false,
    swapSuccess: true,
  }),
  [REQUEST_SWAP_POINT_FOR_CRYPTO_FAILURE]: (state) => ({
    ...state,
    isSwap: false,
    swapFail: true,
    swapSuccess: false,
  }),

  [UPDATE_BODY_SWAP]: (state, _action) => ({
    ...state,
    requestBodySwap: _action.payload,
  }),

  [REQUEST_CALCULATE_POINT_TO_TOKEN]: (state, _action) => ({
    ...state,
    isCalculate: true,
    calculateFail: false,
    calculateSuccess: false,
    swapSuccess: false,
  }),
  [REQUEST_CALCULATE_POINT_TO_TOKEN_SUCCESS]: (state, action) => ({
    ...state,
    tokenAmount: action?.payload?.data,
    isCalculate: false,
    calculateFail: false,
    calculateSuccess: true,
  }),
  [REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE]: (state) => ({
    ...state,
    tokenAmount: 0,
    isCalculate: false,
    calculateFail: true,
    calculateSuccess: false,
  }),

  // check Xaman trust line
  [REQUEST_CHECK_TRUST_LINE]: (state, _action) => ({
    ...state,
    checkingTrustLineWallet: true,
    checkingTrustLineWalletSuccess: false,
    checkingTrustLineWalletFailure: false,
    trustLineResult: null,
  }),
  [REQUEST_CHECK_TRUST_LINE_SUCCESS]: (state, action) => ({
    ...state,
    checkingTrustLineWallet: false,
    checkingTrustLineWalletSuccess: true,
    checkingTrustLineWalletFailure: false,
    trustLineResult: action.payload.data,
  }),
  [REQUEST_CHECK_TRUST_LINE_FAILURE]: (state, action) => ({
    ...state,
    checkingTrustLineWallet: false,
    checkingTrustLineWalletSuccess: false,
    checkingTrustLineWalletFailure: true,
    trustLineResult: action.payload.data,
  }),
});

export default reducer;
export const namespace = 'swapPointForCrypto';

export const actionSwapPointForCrypto = () => ({
  type: ACTION_REQUEST_SWAP_POINT_FOR_CRYPTO,
});

export const swapPointForCryptoAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: '/orders/swap',
    actionTypes: [
      REQUEST_SWAP_POINT_FOR_CRYPTO,
      REQUEST_SWAP_POINT_FOR_CRYPTO_SUCCESS,
      REQUEST_SWAP_POINT_FOR_CRYPTO_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const actionCalculatePointToToken = () => ({
  type: ACTION_REQUEST_CALCULATE_POINT_TO_TOKEN,
});

export const calculatePointToTokenAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: '/exchange/point-to-token',
    actionTypes: [
      REQUEST_CALCULATE_POINT_TO_TOKEN,
      REQUEST_CALCULATE_POINT_TO_TOKEN_SUCCESS,
      REQUEST_CALCULATE_POINT_TO_TOKEN_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const checkTrustLineAPI = (filter) => async (dispatch, getState) => {
  return await callAPI({
    method: 'get',
    apiPath: 'xaman/trustLine/check',
    actionTypes: [
      REQUEST_CHECK_TRUST_LINE,
      REQUEST_CHECK_TRUST_LINE_SUCCESS,
      REQUEST_CHECK_TRUST_LINE_FAILURE,
    ],
    variables: {
      ...filter,
    },
    dispatch,
    getState,
  });
};

export const actionCheckTrustLine = (payload) => ({
  type: ACTION_CHECK_TRUST_LINE,
  payload,
});
